export const derivePipelineNames = pipelines => {
  if (!pipelines) {
    return {};
  }
  const pipelineNames = {};
  pipelines.forEach(pipeline => {
    if (pipeline.id) {
      pipelineNames[pipeline.id] = pipeline.label;
    } else {
      // @ts-expect-error I set the type to either reference or a regular array of API results where pipelineId does exist
      pipelineNames[pipeline.pipelineId] = pipeline.label;
    }
  });
  return pipelineNames;
};